var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
export var ModalWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__ModalWrapper",
  componentId: "kkt6ll-0"
})(["position:fixed;bottom:0;top:0;left:0;right:0;z-index:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.stacking.modal;
});
export var Overlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__Overlay",
  componentId: "kkt6ll-1"
})(["position:fixed;bottom:0;top:0;left:0;right:0;background:", ";opacity:0.6;overflow:hidden;pointer-events:none;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.overlay.dim;
});
export var ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__ContentWrapper",
  componentId: "kkt6ll-2"
})(["display:flex;align-items:flex-end;justify-content:center;width:100%;height:100%;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.tabletPortrait(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: center;\n  "])));
});